var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnswers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2915_2482)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 4.47929 6.44558 0 12 0C17.5523 0 22 4.44772 22 10C22 12.8504 21.0142 14.6929 19.8353 16.1284C19.3845 16.6773 18.8952 17.1776 18.4558 17.6269C18.3448 17.7404 18.2369 17.8507 18.1336 17.9577C17.7791 18.3251 17.4698 18.6622 17.2105 19H13V14.2009L15.5246 12.1762C15.9554 11.8307 16.0243 11.201 15.6787 10.7701C15.3332 10.3393 14.7035 10.2697 14.2727 10.6153L11.981 12.4532L9.71365 10.6348C9.2828 10.2893 8.65312 10.3588 8.30759 10.7896C7.96206 11.2205 8.03091 11.8502 8.46175 12.1958L11 14.2314V19H6.78953C6.53024 18.6622 6.2209 18.3251 5.86636 17.9577C5.76309 17.8507 5.65523 17.7404 5.54422 17.6269L5.54388 17.6266C5.10446 17.1773 4.61549 16.6773 4.16471 16.1284C2.98581 14.6929 2 12.8504 2 10ZM7.46922 21L7.57538 21.4246L7.60692 21.5517C7.73516 22.0701 7.86354 22.5892 8.17 22.9984C8.43645 23.3543 8.79297 23.6327 9.20281 23.8048C9.67419 24.0029 10.2089 24.0016 10.743 24.0002L10.8739 24H13.1261L13.257 24.0002C13.7911 24.0016 14.3258 24.0029 14.7972 23.8048C15.207 23.6327 15.5635 23.3543 15.83 22.9984C16.1365 22.5892 16.2648 22.0701 16.3931 21.5517L16.4246 21.4246L16.5308 21H7.46922Z",
    fill: "#322267"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2915_2482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswers);
export default __webpack_public_path__ + "static/media/answers.e284a4d040446870e878db4d1ad11786.svg";
export { ForwardRef as ReactComponent };